'use strict';
import {USER_PRIORITY} from '../enums/USER_PRIORITIES';

export const PRIORITIES_LIST_NAME = 'priorities';

const TOGGLE_PIN = `${PRIORITIES_LIST_NAME}/TOGGLE_PIN`;
const TOGGLE_PIN_SUCCESS = `${PRIORITIES_LIST_NAME}/TOGGLE_PIN_SUCCESS`;
const TOGGLE_PIN_ERROR = `${PRIORITIES_LIST_NAME}/TOGGLE_PIN_ERROR`;
const SWEEP_LIST = `${PRIORITIES_LIST_NAME}/SWEEP_LIST`;
const SWEEP_LIST_SUCCESS = `${PRIORITIES_LIST_NAME}/SWEEP_LIST_SUCCESS`;
const SWEEP_LIST_ERROR = `${PRIORITIES_LIST_NAME}/SWEEP_LIST_ERROR`;

/**
 * @typedef {ReduxObservableListActions} PriorityListActions
 * @property {Function|ReduxActionCreator} togglePin
 */

/**
 * @return {ReduxAction}
 */
export function sweepList() {
  return {
    type: SWEEP_LIST,
    payload: {},
  };
}
sweepList.TYPE = SWEEP_LIST;

/**
 * @return {ReduxAction}
 */
export function sweepListSuccess() {
  return {
    type: SWEEP_LIST_SUCCESS,
    payload: {},
  };
}
sweepListSuccess.TYPE = SWEEP_LIST_SUCCESS;

/**
 * @typedef {Object} SweepListErrorPayload
 * @property {Error} err
 */

/**
 * @param {SweepListErrorPayload} payload
 * @return {ReduxAction<SweepListErrorPayload>}
 */
export function sweepListError(payload) {
  return {
    type: SWEEP_LIST_ERROR,
    payload,
  };
}
sweepListError.TYPE = SWEEP_LIST_ERROR;

/**
 * @typedef {Object} TogglePinPayload
 * @property {String} id
 * @property {Number} priority
 */

/**
 * @param {TogglePinPayload} payload
 * @return {ReduxAction<TogglePinPayload>}
 */
export function togglePin(payload) {
  return {
    type: TOGGLE_PIN,
    payload,
  };
}
togglePin.TYPE = TOGGLE_PIN;

/**
 * @typedef {TogglePinPayload} AutoTogglePinPayload
 * @property {Object} model
 */

/**
 * @param deleteItemAction
 * @return {Function}
 */
export function buildTogglePinCreator(deleteItemAction) {
  /**
   * @param {AutoTogglePinPayload} payload
   * @return {ReduxAction<AutoTogglePinPayload>}
   */
  return function ({model, id, priority}) {
    if (priority === USER_PRIORITY.PINNED) {
      return togglePin({id, priority});
    } else if (priority === USER_PRIORITY.AUTO_PINNED && model.serverPriority === USER_PRIORITY.AUTO_PINNED) {
      return togglePin({id, priority});
    } else {
      return deleteItemAction({id});
    }
  };
}

/**
 * @typedef {Object} TogglePinSuccessPayload
 * @property {String} id
 * @property {Number} priority
 */

/**
 * @param {TogglePinSuccessPayload} payload
 * @return {ReduxAction<TogglePinSuccessPayload>}
 */
export function togglePinSuccess(payload) {
  return {
    type: TOGGLE_PIN_SUCCESS,
    payload,
  };
}
togglePinSuccess.TYPE = TOGGLE_PIN_SUCCESS;

/**
 * @typedef {Object} TogglePinErrorPayload
 * @property {String} id
 * @property {Number} priority
 */

/**
 * @param {TogglePinErrorPayload} payload
 * @return {ReduxAction}
 */
export function togglePinError(payload) {
  return {
    type: TOGGLE_PIN_ERROR,
    payload,
  };
}
togglePinError.TYPE = TOGGLE_PIN_ERROR;



// WEBPACK FOOTER //
// ./src/js/priorities/actions/prioritiesListActions.js